import { useState } from "react";
import { SectionTitle } from "../_shared/section-title";
import { PageShell, Stack } from "../_shared/page-shell";
import { Card } from "../_shared/card";
import { IconCheck, IconSignature } from "../_shared/icons";
import { children, type Child } from "../_data/mock";
import { useDemo } from "../_shared/demo.provider";

const kindHints: Record<string, string> = {
  cgu: "Cabinet — version du 1er Jan. 2027",
  devis: "Préparé par Dr Renoud",
  photo: "Séance photo demandée par le cabinet",
  temoignage: "Témoignage demandé par le cabinet",
  exercice: "Validation hebdomadaire",
  questionnaire: "À remplir avant le prochain rendez-vous",
  rdv: "Confirmation de créneau",
};

const childRing = {
  orange:
    "ring-[var(--child-1-primary)] bg-[var(--child-1-light)] text-[var(--child-1-primary)]",
  blue: "ring-[var(--child-2-primary)] bg-[var(--child-2-light)] text-[var(--child-2-primary)]",
} as const;

export function SignaturesPage() {
  const { signatures, signSignature } = useDemo();
  const [childId, setChildId] = useState<Child["id"]>(
    children[0]?.id ?? "jeanne",
  );
  const visibleSignatures = signatures.filter(
    (s) => !s.childId || s.childId === childId,
  );

  return (
    <>
      <SectionTitle title="Signatures" />
      <PageShell>
        <Stack>
          <Card title="Pour qui ?">
            <ul className="flex flex-wrap gap-2 pt-1">
              {children.map((c) => {
                const selected = childId === c.id;
                return (
                  <li key={c.id}>
                    <button
                      type="button"
                      onClick={() => setChildId(c.id)}
                      className={`inline-flex h-10 items-center rounded-full px-4 text-[14px] font-semibold ring-1 transition ${selected ? childRing[c.color] : "bg-[var(--surface-1)] text-[var(--text-2)] ring-[var(--border-1)] hover:bg-[var(--surface-2)]"}`}
                    >
                      {c.firstName}
                    </button>
                  </li>
                );
              })}
            </ul>
          </Card>

          {visibleSignatures.length === 0 ? (
            <Card title="Tout est signé">
              <p className="text-[13px] text-[var(--text-2)]">
                Aucune signature en attente. Vous recevrez une notification dès
                qu'un nouveau document sera disponible.
              </p>
            </Card>
          ) : (
            visibleSignatures.map((s) => (
              <Card
                key={s.id}
                title={
                  <span className="flex items-center gap-2">
                    <IconSignature
                      width={18}
                      height={18}
                      className="text-[var(--text-2)]"
                    />
                    {s.label}
                  </span>
                }
              >
                <div className="flex items-center justify-between gap-3">
                  <p className="text-[13px] text-[var(--text-2)]">
                    {kindHints[s.kind] ?? ""}
                  </p>
                  <button
                    type="button"
                    onClick={() => signSignature(s.id)}
                    className="inline-flex h-9 items-center gap-1.5 rounded-full bg-[var(--sf-primary)] px-3.5 text-[12.5px] font-semibold text-white shadow-sm transition active:scale-95"
                  >
                    <IconCheck width={14} height={14} strokeWidth={2.5} />
                    Signer
                  </button>
                </div>
              </Card>
            ))
          )}
        </Stack>
      </PageShell>
    </>
  );
}
